import {cn} from "@adleritech/web-ui/utils";
import styles from "./Overline.module.css";

export type OverlineProps = React.HTMLAttributes<HTMLDivElement>;

export function Overline({className, ...props}: OverlineProps) {
    return <div className={cn(styles.wrapper, className)} {...props} />;
}

export type OverlineLinkProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export function OverlineLink({className, ...props}: OverlineLinkProps) {
    return (
        <button className={cn(styles.wrapper, styles.link, className)} type="button" {...props} />
    );
}
